define('lq/point',['lq/drop'], function (Drop) {
	'use strict';

	var Point = function(x, y) {
		this.x = x || 0;
		this.y = y || 0;
	};
	
	Point.prototype.fromPosition = function(position) {
		this.x = position.left;
		this.y = position.top;
		return this;
	};

	Point.prototype.fromPositionToZoomPosition = function (position) {
	    this.x = position.left * (1 / Drop.zoomlevel);
	    this.y = position.top * (1 / Drop.zoomlevel);
	    return this;
	};
	
	Point.prototype.fromPositionXAndY = function (position) {
		this.x = position.x;
		this.y = position.y;
		return this;
	};

	Point.prototype.x = null;
	Point.prototype.y = null;

	Point.prototype.toPositionXAndY = function () {
	    return {
	        x: this.x,
	        y: this.y
	    };
	};

	Point.prototype.toPosition = function () {
	    return {
	        left: this.x,
	        top: this.y
	    };
	};

	Point.prototype.add = function (v) {
		return new Point(this.x + v.x, this.y + v.y);
	};

	Point.prototype.subtract = function (v) {
		return new Point(this.x - v.x, this.y - v.y);
	};

	Point.prototype.multiply = function (v) {
		return new Point(this.x * v, this.y * v);
	};

	Point.prototype.divide = function (v) {
		return new Point(this.x / v, this.y / v);
	};

	Point.prototype.abs = function () {
		return new Point(Math.abs(this.x), Math.abs(this.y));
	   };

	Point.prototype.clone = function () {
		return new Point(this.x, this.y);
	};

	Point.prototype.distance = function (v) {
		var delta = this.subtract(v);
		return Math.sqrt(delta.multiplyScalar(delta));
	};

	Point.prototype.multiplyScalar = function (v) {
		return this.x * v.x + this.y * v.y;
	};

	Point.prototype.rot90 = function () {
		return new Point(-this.y, this.x);
	};

	Point.prototype.rot270 = function () {
		return new Point(this.y, -this.x);
	};

	return Point;

});


